import { render } from "./Customers.vue?vue&type=template&id=03ebefe3&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "ag-grid-community/dist/styles/ag-theme-alpine.css?vue&type=style&index=0&lang=css"
import "ag-grid-community/dist/styles/ag-grid.css?vue&type=style&index=1&lang=css"
import "./Customers.vue?vue&type=style&index=2&id=03ebefe3&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4281202222/src/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ebefe3"]])

export default __exports__